/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：538
 */

module.exports = function (e) {
  return null != e && "object" == typeof e
}
